import loadingImage from 'utils/images/loadingImage';

// Cache of loaded watermark logos keyed by logoId, populated when a logo/sticker is selected
// (watermarkGeneratorInit). Per-item Apply resolves each item's own logo from here — needed because
// sticker URLs aren't persisted in Redux, so the loaded image is the only thing available at apply time.
const cache = new Map<string, HTMLImageElement>();

export const cacheLogo = (logoId: string, img: HTMLImageElement) => {
  cache.set(logoId, img);
};

export const getCachedLogo = (logoId: string) => cache.get(logoId);

export const resolveLogo = async (logoId: string, url: string) => {
  const hit = cache.get(logoId);
  if (hit) return hit;
  const img = await loadingImage(url);
  cache.set(logoId, img);
  return img;
};

export const clearLogoCache = () => {
  cache.clear();
};
